import { render, staticRenderFns } from "./RolesContainer.vue?vue&type=template&id=a09b4b14&"
import script from "./RolesContainer.vue?vue&type=script&lang=js&"
export * from "./RolesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports